module.exports = __webpack_public_path__ + "static/coastline-00928d5aadbb3a98c3f3ce300e556ef6.jpg";